<div
  class="row items-center justify-between toolbar p-16"
  cdkDrag cdkDragHandle
  cdkDragRootElement=".cdk-overlay-pane"
  cdkDragBoundary=".cdk-overlay-container"
>
  @if (isNew) {
    <span>{{ 'Naplánování automatického plnění ukládacích jednotek' | translate }}</span>
  } @else {
    <div class="row">
      <icz-tag [label]="('en.storageUnitFillerState.' + formValue.storageUnitFillerState!) | translate"
               class="state-tag"
               [color]="stateTagColor">
      </icz-tag>
      <span>{{ 'Automatické plnění ukládacích jednotek' | translate }}</span><span>{{ formValue.id }}</span>
    </div>
  }

  <icz-button svgIcon="close" (onAction)="cancel()" transparent disableRipple size="small" iczTooltip="Zavřít"></icz-button>
</div>

<icz-tabs class="grow tabs" [tabs]="tabs" (tabClick)="tabChanged($event)" [activeTab]="currentActiveTab">
  <ng-template [iczTab]="StorageUnitFillerTabs.SETTINGS">
    <form [formGroup]="form" [waiting]="loadingService.isLoading$(this) | async" class="m-24">
      <div class="row">
        <div class="col grow">
          <icz-section label="Naplánování dávky">
            <icz-radio-group formControlName="finalRun">
              <icz-label class="icz-body-1 mb-8" label="Chcete spustit zkušební nebo finální uložení?"></icz-label>
              <icz-radio-button label="Testovací spuštění" [value]="false"></icz-radio-button>
              <icz-radio-button label="Finální spuštění" [value]="true"></icz-radio-button>
            </icz-radio-group>
            <icz-form-field [fieldDisabled]="true"
              [value]="formValue.scheduledRunAt | localizedDatetime"
              label="Datum příštího běhu">
            </icz-form-field>
            <icz-form-field [fieldDisabled]="true"
              [value]="formValue.lastRunAt | localizedDatetime"
              label="Datum posledního běhu">
            </icz-form-field>
          </icz-section>
          <icz-form-autocomplete
            formControlName="registryOfficeId"
            label="Spisovna"
            [options]="registryOfficeOptions"
          ></icz-form-autocomplete>
          @if (!this.isPredefinedRegistryOfficeAvailableForMe) {
            <icz-alert
              severity="error" class="mb-16 mt-4"
              heading="Nemáte přístup k přednastavené spisovně. Kontaktujte administrátora."
            ></icz-alert>
          }
          @if (!isNew) {
            <div class="row">
              <icz-icon suffix size="small" svgIcon="info"></icz-icon>
              <span>{{ toInsertEntitiesLabel }}</span>
            </div>
          }

          <span class="icz-body-1 mt-4">{{ 'Kritéria výběru objektů ze seznamu ukončených:' | translate }}</span>

          @if (humanReadableFilter) {
            <span class="icz-body-1 mt-4" [innerHTML]="humanReadableFilter"></span>
          }
          @if (isNew && modalData.isUnitView) {
            <div class="row mt-4">
              <span>{{ 'Vybraný útvar:' | translate }}</span>
              @if (orgUnitId) {
                <span>{{ orgUnitId | findInList: organizationalUnitsOptions }}</span>
              } @else {
                <span>{{ 'Všechny útvary' }}</span>
              }
            </div>
          }
          @if (isNew) {
            <icz-button
              class="inline-block mt-8"
              label="Vybrat kritéria výběru objektů" (onAction)="selectObjects()"
            ></icz-button>
          }
        </div>
        <div class="col grow">
          @if (!isNew && modalData.storageUnitFiller!.statistics!) {
            <icz-section label="Průběh dávky">
              @if (isFinished) {
                <div>
                  <a class="p-4" iczLinkWithoutHref>
                    {{ 'Založeno ukládacích jednotek:' | translate }}
                  </a>
                  <span>{{ statistics!.storageUnitsInsertedCount }}</span>
                </div>
                <div>
                  <a class="p-4" iczLinkWithoutHref>
                    {{ 'Úspěšně uloženo objektů:' | translate }}
                  </a>
                  <span>{{ statistics!.entitiesInsertedCount }}</span>
                </div>
                <div>
                  <a class="p-4" iczLinkWithoutHref>
                    {{ 'Objektů které se nepodařilo uložit:' | translate }}
                  </a>
                  <span>{{ statistics!.entitiesRejectedCount }}</span>
                </div>
              }
              @if (isTested) {
                <div>
                  <a class="p-4" iczLinkWithoutHref>
                    {{ 'Očekávaných ukládacích jednotek:' | translate }}
                  </a>
                  <span>{{ statistics!.storageUnitsExpectedCount }}</span>
                </div>
              }
            </icz-section>
          }
          <icz-section label="Popis vytvářených ukládacích jednotek">
            <icz-form-autocomplete
              formControlName="enforceStrictDisposalSchedule"
              label="Ukládací jednotky budou obsahovat pouze shodné skartační režimy"
              [options]="booleanOptions"
            ></icz-form-autocomplete>
            <icz-form-autocomplete
              formControlName="enforceStrictEntityClass"
              label="Ukládací jednotky budou obsahovat pouze shodnou věcnou skupinu"
              [options]="booleanOptions"
            ></icz-form-autocomplete>
            <icz-form-autocomplete
              formControlName="enforceStrictDisposalYear"
              label="Ukládací jednotky budou obsahovat pouze objekty se shodným rokem vyřazení"
              [options]="booleanOptions"
            ></icz-form-autocomplete>
            <icz-form-field
              formControlName="note"
              label="Popis"
            ></icz-form-field>
            <icz-form-field [fieldDisabled]="true"
              [value]="auditInfo?.createdBy!"
              label="Dávku založil"
            ></icz-form-field>
          </icz-section>
          <icz-section label="Klíče určující cílovou ukládající jednotku">
            <icz-form-autocomplete
              formControlName="classificationAttributes"
              label="Klíče určující cílovou ukládající jednotku"
              [options]="classificationAttributeOptions"
              [clearable]="false"
              [isMultiselect]="true"
            ></icz-form-autocomplete>
          </icz-section>
        </div>
      </div>
    </form>
  </ng-template>

  <ng-template [iczTab]="StorageUnitFillerTabs.CONTENT_STORAGE_UNITS">
    @if (contentStorageUnitsDataSource) {
      <icz-storage-units-table
        tableTitle=""
        tableId="storage-unit-filler-content-storage-units"
        [viewType]="StorageUnitView.STORAGE_UNIT_FILLER_CONTENT_STORAGE_UNITS"
        [dataSource]="contentStorageUnitsDataSource"
      ></icz-storage-units-table>
    }
  </ng-template>

  <ng-template [iczTab]="StorageUnitFillerTabs.CONTENT_ENTITIES">
    @if (contentEntitiesDataSource) {
      @if (activeRow) {
        <icz-document-file-sidebar
          [entityId]="activeRow.entityId"
          [entityType]="activeRow.entityType"
          [isConstrainedView]="false"
          [opened]="openQuickPreview"
          (closed)="entitiesTable?.unsetActiveRow()"
        ></icz-document-file-sidebar>
      }

      <icz-table
        #entitiesTable
        tableTitle=""
        id="storage-unit-filler-content-entities"
        [dataSource]="contentEntitiesDataSource"
        [columnsData]="contentEntitiesColumnData"
        [config]="contentEntitiesConfig"
        (selectedRowsChanged)="selectedRows = $event"
        (activeRowChanged)="setActiveRow($event)"
        (contextMenuRequested)="toolbar.openContextMenu($event)"
      >
        <icz-storage-unit-filler-content-toolbar-buttons
          tools #toolbar
          [storageUnitFiller]="modalData.storageUnitFiller!"
          [selectedRows]="selectedRows"
          (operationCompleted)="contentEntitiesDataSource.reload(true)"
        ></icz-storage-unit-filler-content-toolbar-buttons>

        <ng-container *iczColumnTemplate="let row from [contentEntitiesDataSource, contentEntitiesColumnData]; id: 'objectClass'">
          <icz-table-entity-icon
            [documentsTableEntity]="$any(row)"
            [view]="StorageUnitView.STORAGE_UNIT_FILLER_CONTENT_ENTITIES"
          ></icz-table-entity-icon>
        </ng-container>
        <ng-container *iczColumnTemplate="let row from [contentEntitiesDataSource, contentEntitiesColumnData]; id: 'refNumber'; withEllipsis: true">
          @if (row.refNumber) {
            <span>{{ row.refNumber }}</span>
          } @else {
            <span class="icz-text-muted" [iczTooltip]="WITHOUT_REF_NUMBER | translate">
              {{ WITHOUT_REF_NUMBER | translate }}
            </span>
          }
        </ng-container>
        <ng-container *iczColumnTemplate="let row from [contentEntitiesDataSource, contentEntitiesColumnData]; id: 'error'">
          @if (row.error) {
            <div class="row">
              <icz-icon svgIcon="error" size="default"></icz-icon>
              {{ row.error }}
            </div>
          }
        </ng-container>

      </icz-table>
    }
  </ng-template>
</icz-tabs>

<icz-form-buttons>
  <icz-button leftButtons iczFormSubmit
              [disabled]="loadingService.isLoading(this) || isFinished"
              (onAction)="submit()"
              primary label="Uložit"
  ></icz-button>
  @if (isTested) {
    <ng-container leftButtons>
      <icz-button [disabled]="loadingService.isLoading(this)"
                  (onAction)="rescheduleAsPlanned(false)"
                  label="Znovu naplánovat jako zkušební"
      ></icz-button>
      <icz-button [disabled]="loadingService.isLoading(this)"
                  (onAction)="rescheduleAsPlanned(true)"
                  label="Znovu naplánovat jako finální"
      ></icz-button>
      <icz-button [disabled]="loadingService.isLoading(this)"
                  (onAction)="delete()"
                  label="Zrušit dávku"
      ></icz-button>
    </ng-container>
  }
  @if (isPlanned) {
    <ng-container leftButtons>
      <icz-button [disabled]="loadingService.isLoading(this)"
                  (onAction)="delete()"
                  label="Zrušit dávku"
      ></icz-button>
    </ng-container>
  }
  <icz-button rightButtons
              [disabled]="loadingService.isLoading(this)"
              (onAction)="cancel()" label="Storno"
  ></icz-button>
</icz-form-buttons>
